export type OverlayRect = {
    x: number;
    y: number;
    width: number;
    height: number;
};

export type VideoLayoutRect = OverlayRect;

export function clamp(value: number, min: number, max: number): number {
    return Math.min(max, Math.max(min, value));
}

export function bboxOverlayToSourcePixels(
    overlayBbox: OverlayRect,
    videoRect: VideoLayoutRect,
    sourceWidth: number,
    sourceHeight: number,
): [number, number, number, number] {
    const safeVideoW = videoRect.width > 0 ? videoRect.width : 1;
    const safeVideoH = videoRect.height > 0 ? videoRect.height : 1;
    const safeSourceW = sourceWidth > 0 ? sourceWidth : 1;
    const safeSourceH = sourceHeight > 0 ? sourceHeight : 1;

    const relLeft = (overlayBbox.x - videoRect.x) / safeVideoW;
    const relTop = (overlayBbox.y - videoRect.y) / safeVideoH;
    const relW = overlayBbox.width / safeVideoW;
    const relH = overlayBbox.height / safeVideoH;

    const x1 = Math.round(clamp(relLeft, 0, 1) * safeSourceW);
    const y1 = Math.round(clamp(relTop, 0, 1) * safeSourceH);
    const x2 = Math.round(clamp(relLeft + relW, 0, 1) * safeSourceW);
    const y2 = Math.round(clamp(relTop + relH, 0, 1) * safeSourceH);

    return [x1, y1, x2, y2];
}
